import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { QualysService } from '../../service';

export type WasVulnerabilityScanningConfig = typeof WasVulnerabilityScanningConfig._.Config;

export const WasVulnerabilityScanningConfig = IntegrationConfig.make({
  service: QualysService,
  name: Integration_Handler_Names_Enum.WasVulnerabilityScanning,
  configSchema: z.object({
    webAppIds: z.array(z.number().positive()).min(1),
  }),
});
